import { Component, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { MemberInformationService } from '../member-information.service';
import { DumbResourcePage } from '../DTOs/dumb-resource-page';
import { GetMemberResourcesRequest } from '../DTOs/get-member-resources-request';

@Component({
  selector: 'app-resources-list',
  templateUrl: './resources-list.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ResourcesDirectoryListComponent {
    constructor(private memberInformationService: MemberInformationService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService) {  }

    resources: DumbResourcePage[] = [];

    categorySearch = -1;
    searchText = "";

    ngOnInit() {
        this.searchResources();
    }

    searchResources() {
        this.blockUI.start();
        this.searchResourcesObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.resources = data;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                        if (this.resources.length == 0) {
                            console.log(" no resources found ")
                        }
                    }
                });
    }

    searchResourcesObservable(): Observable<DumbResourcePage[]> {
        var req = new GetMemberResourcesRequest(this.searchText, this.categorySearch);
        return this.
            memberInformationService.searchMemberResources(req);
    }
}

